import { Pipe, PipeTransform } from '@angular/core';
import { User } from 'src/app/rgs/components/admin/components/user/models/user.model';

@Pipe({ name: 'userInfo' })
export class UserInfoPipe implements PipeTransform {
  public transform(user: User): string {
    let result = '';

    if (user?.givenName) {
      result += user.givenName;
    }

    if (user?.familyName) {
      if (result) {
        result += ' ';
      }
      result += user.familyName;
    }

    if (user?.email) {
      if (result) {
        result += ' ';
      }
      result += ` (${user.email})`;
    }

    return result;
  }
}
